











































































import { defineComponent } from '@nuxtjs/composition-api';
import BaseButton from '@shared/components/@atoms/BaseButton/BaseButton.vue';

export default defineComponent({
  name: 'BaseBullets',
  inject: {
    components: {
      default: { BaseButton },
    },
  },
  props: {
    total: {
      type: Number,
      default: 3,
    },
    current: {
      type: Number,
      default: 0,
    },
    longBullets: {
      type: Boolean,
      default: false,
    },
  },
  data(...args): any {
    return args;
  },
  // @ts-ignore migrated from ui-library
  inactiveRight(total, current) {
    return total - 1 - current;
  },
  // @ts-ignore migrated from ui-library
  inactiveLeft(total, current) {
    return total - (total - 1 - current) - 1;
  },
});
